import Vue from 'vue'
import {STORAGE_KEY} from '../constants/App'
import Modal from '../components/common/Modal'
import CorpConfigModal from '../components/common/CorpConfigModal'
import CorpInfoModal from '../components/common/CorpInfoModal'
import EstimateConfigModal from '../components/common/EstimateConfigModal'
import NestingConfigModal from '../components/common/NestingConfigModal'
import SystemConfigModal from '../components/common/SystemConfigModal'
import UserManageModal from '../components/common/UserManageModal'
import CostCustomConfigModal from '../components/common/CostCustomConfigModal'
import BomCustomConfigModal from '../components/common/BomCustomConfigModal'
import UserModal from '../components/common/UserModal'
import SupportModal from '../components/common/SupportModal'
import EditingFileModal from '../components/common/EditingFileModal'
import EditingModal from '../components/common/EditingModal'
import OrderSearchModal from '../components/order/OrderSearchModal'
import OrderDispModal from '../components/order/OrderDispModal'
import InputModal from '../components/common/InputModal'
// import ToolTip from '../components/common/ToolTip'

/** アプリケーション共通ユーティリティ */

/**
 * ローカルモード判定
 */
export const isLocal = () => {
  return process.env.NODE_ENV === 'local'
}

/**
 * 開発モード判定
 */
export const isDev = () => {
  return process.env.NODE_ENV === 'development'
}

/**
 * darosの画像のURLを取得
 */
export const getDarosResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/daros/' + imagePath
}

/**
 * mmstyleの画像のURLを取得
 */
export const getMmstyleResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/mmstyle/' + imagePath
}

/**
 * mmstyleのコンテンツを取得
 */
export const getMmstyleContents = (content) => {
  return process.env.RESOURCE_URL + 'contents/mmstyle/' + content
}

/**
 * kagullの画像のURLを取得
 */
export const getKagullResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/kagull/' + imagePath
}

/**
 * コンテンツの画像のURLを取得
 */
export const getContentsResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'contents/' + imagePath
}

/**
 * コンテンツのスケッチオーダー画像のURLを取得
 */
export const getContentsSkupResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'contents/skup/' + imagePath
}

/**
 * ログインユーザー情報取得
 * ※設定箇所はLogin.vue参照
 * @return { corpName, userName }
 */
export const getUserInfo = () => {
  let userInfo = localStorage.getItem(STORAGE_KEY.USER_INFO)
  return userInfo ? JSON.parse(userInfo) : {}
}

/**
 * ローカルストレージ取得
 * @return
 */
export const getLocalStorage = (key) => {
  let json = localStorage.getItem(key)
  return json ? JSON.parse(json) : {}
}

/**
 * ローカルストレージ上書設定
 * @return
 */
export const setLocalStorage = (key, obj) => {
  return localStorage.setItem(key, JSON.stringify(obj))
}

/**
 * ローカルストレージ追加設定
 * @return
 */
export const addLocalStorage = (key, addObj) => {
  let json = localStorage.getItem(key)
  let obj = json ? JSON.parse(json) : {}
  let merged = Object.assign(obj, addObj)
  return localStorage.setItem(key, JSON.stringify(merged))
}

/**
 * ローカルストレージ削除
 * @return
 */
export const removeLocalStorage = (key) => {
  return localStorage.removeItem(key)
}

/**
 * 共通モーダル表示
 * 利用方法：
 * let modalData = {
 *   title: 'タイトル',
 *   messages: ['メッセージ', '複数項目に分けて引渡すと改行して表示する'],
 *   modalType: 'message', // or 'confirm'
 *   messageType: 'info', // or 'success' or 'error'
 *   textAlign: 'center', // or 'left'
 *   onOk: () => { OKボタン押下時のコールバック関数を定義 },
 *   onCancel: () => { キャンセルボタン押下時のコールバック関数を定義 },
 *   callbackParams: { コールバック関数に渡す引数を定義 }
 * }
 * App.showModal(modalData)
 */
export const showModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-modal': Modal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-modal
        :title="modalData.title"
        :messages="modalData.messages"
        :modalType="modalData.modalType"
        :messageType="modalData.messageType"
        :textAlign="modalData.textAlign"
        :okBtnLabel="modalData.okBtnLabel"
        :cancelBtnLabel="modalData.cancelBtnLabel"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** 企業設定モーダル表示 */
export const showCorpConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#corp-config-modal',
    components: { 'dd-corp-config-modal': CorpConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-corp-config-modal ref="corpConfigModalRef"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
        :routeOrderList="modalData.routeOrderList" 
      />
    `
  }).$children[0]
  modal.showModal()
}
/** 登録情報設定表示 */
export const showCorpInfoModal = (modalData) => {
  let modal = new Vue({
    el: '#register-config-modal',
    components: { 'dd-corp-info-modal': CorpInfoModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-corp-info-modal ref="corpInfoModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal(modalData)
}
/** ユーザ管理モーダル表示 */
export const showUserManageModal = (modalData) => {
  let modal = new Vue({
    el: '#user-manage-modal',
    components: { 'dd-user-manage-modal': UserManageModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-user-manage-modal ref="userManageModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** ユーザーに関する処理のモーダル表示 */
export const showUserModal = (isNew, isDel, Obj) => {
  let modal = new Vue({
    el: '#add-user-modal',
    components: { 'dd-user-modal': UserModal },
    data () {
      return {
        isNew: isNew,
        isDel: isDel,
        userObj: Obj
      }
    },
    template: `
      <dd-user-modal ref="userModalRef"
        :isNew="isNew"
        :isDel="isDel"
        :userObj="userObj"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 見積もり設定表示 */
export const showEstimateConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#estimate-config-modal',
    components: { 'dd-estimate-config-modal': EstimateConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-estimate-config-modal ref="estimateConfigModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** ネスティング設定表示 */
export const showNestingConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#nesting-config-modal',
    components: { 'dd-nesting-config-modal': NestingConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-nesting-config-modal ref="nestingConfigModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** システム設定表示 */
export const showSystemConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#system-config-modal',
    components: { 'dd-system-config-modal': SystemConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-system-config-modal ref="systemConfigModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** 価格カスタム設定表示 */
export const showCostCustomConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#cost-custom-config-modal',
    components: { 'dd-cost-custom-config-modal': CostCustomConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-cost-custom-config-modal ref="costCustomConfigModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** 構成明細カスタム設定表示 */
export const showBomCustomConfigModal = (modalData) => {
  let modal = new Vue({
    el: '#bom-custom-config-modal',
    components: { 'dd-bom-custom-config-modal': BomCustomConfigModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-bom-custom-config-modal ref="bomCustomConfigModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** お問い合わせモーダル表示 */
export const showContactModal = () => {
  let modal = new Vue({
    el: '#support-modal',
    components: { 'dd-support-modal': SupportModal },
    template: `
      <dd-support-modal />
    `
  }).$children[0]
  modal.showModal()
}
/** 編集中ファイル強制解除モーダル表示 */
export const showEditingFileModal = (modalData) => {
  let modal = new Vue({
    el: '#editing-file-modal',
    components: { 'dd-editing-file-modal': EditingFileModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-editing-file-modal ref="editingFileModalRef"
        :prevDialog="modalData.prevDialog"
      />
    `
  }).$children[0]
  modal.showModal()
}
/** 編集中ファイル強制解除確認モーダル表示 */
export const showEditingModal = (Obj) => {
  let modal = new Vue({
    el: '#editing-modal',
    components: { 'dd-editing-modal': EditingModal },
    data () {
      return {
        fileObj: Obj
      }
    },
    template: `
      <dd-editing-modal ref="editingModalRef"
        :fileObj="fileObj"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 受注リスト条件絞り込みダイアログ */
export const showOrderSearchModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-order-search-modal': OrderSearchModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-order-search-modal ref="orderSearchModalRef"
        :onSearch="modalData.onSearch"
        :callbackParams="modalData.callbackParams"
        :refSearchForm="modalData.refSearchForm"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 受注リスト表示/非表示ダイアログ */
export const showOrderDispModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-order-disp-modal': OrderDispModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-order-disp-modal ref="orderDispModalRef"
        :onDisp="modalData.onDisp"
        :callbackParams="modalData.callbackParams"
        :refDispForm="modalData.refDispForm"
        :defaultDispForm="modalData.defaultDispForm"
      />
    `
  }).$children[0]
  modal.showModal()
}

export const showEditModal = (modalData) => {
  // 入力用モーダルの作成
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-input-modal': InputModal },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-input-modal ref="inputRef"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
        :showSuccess="modalData.showSuccess"
        :defaultText="modalData.defaultText"
        :top="modalData.top"
        :left="modalData.left"
      />
    `
  }).$children[0]
  modal.showModal()
}



// WEBPACK FOOTER //
// ./src/main/js/utils/App.js